import { COLORS } from "../constants";

export const styles = {
  topBar: {
    background: COLORS.primary,
    color: COLORS.white,
    padding: "5px 1px",
    borderBottom: `1px solid ${COLORS.border}`,
  },
  header: {
    background: COLORS.primary,
    padding: "0 0px",
    // borderBottom: `2px solid ${COLORS.border}`,
  },
  fixheader: {
    background: COLORS.primary,
    padding: "0 5%",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1000, 
  },
  menu: {
    background: COLORS.primary,
    borderBottom: "none",
    display: "flex",
    justifyContent: "center",
    height: '59px',
  },
  menutitle:{
    color: "white",
  },
  textWhite: {
    color: "white",
    cursor: "pointer",
  },
  logosize: {
    height: "auto",
    maxWidth: "189px", // Adjust this value based on your design
    display: "block",
    // margin: "0 auto", // Centers the logo
  },
  menuButton: {
    // color: COLORS.white,
    color: "white",
    width: "30px",
    width: "100%",
    justifyContent: "flex-start"


  },
  iconButton: {
    color: COLORS.white,
  },
};
